// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".protectedBodyPage header,.protectedBodyPage .root,.protectedBodyPage .xf__base{display:none}", ""]);
// Exports
module.exports = exports;
